// src/utils/support.js

/**
 * GET or CREATE a persistent Support ID for this device.
 * Uses secure crypto.randomUUID with a fallback.
 */
export const getSupportId = (reuse=true) => {
  let id = reuse? localStorage.getItem("support_id"): null;

  if (!id) {
    // 1. Use the secure, built-in browser UUID generator (Preferred)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      id = crypto.randomUUID();
    } 
    // 2. Fallback to a compliant manual generator if crypto is unavailable
    else {
      id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (c) => {
        const r = Math.trunc(Math.random() * 16);
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
    localStorage.setItem("support_id", id);
  }
  return id;
};

export const resetSupportId = () => {

  return getSupportId(false);
};
